/**
 * @param {string} imageUrl
 * @param {{ aspectRatio: string, width: number, height: number }} variant
 */
export function getCruiseImageUrl(imageUrl, { aspectRatio, width, height }) {
  const hashIndex = imageUrl.indexOf('#');
  const urlWithoutHash = hashIndex === -1 ? imageUrl : imageUrl.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : imageUrl.slice(hashIndex);
  const queryIndex = urlWithoutHash.indexOf('?');
  const pathname = queryIndex === -1 ? urlWithoutHash : urlWithoutHash.slice(0, queryIndex);
  const queryString = queryIndex === -1 ? '' : urlWithoutHash.slice(queryIndex + 1);
  const params = new URLSearchParams(queryString);

  params.set('wid', String(width));
  params.set('hei', String(height));

  return `${pathname}:${aspectRatio}?${params.toString()}${hash}`;
}